// This file is kept for compatibility but redirects to Landing
import { Navigate } from 'react-router-dom';

export default function Home() {
  return <Navigate to="/Landing" replace />;
}
